<template>
  <div class="content-wrapper">
    <SendGiftMenu
      header="Link a Salesforce record"
      :displayStepper="true"
      back-to="CardMessage"
    />

    <div class="salesforce-container">
      <!-- Display Message Here -->
      <div class="display-message">
        <p>
          Link a Salesforce record to track gift ordering, shipping and
          delivery.
        </p>
        <div class="image-holder">
          <Gemstripe />
        </div>
      </div>
      <form @submit.prevent>
        <!-- Resource Here -->
        <div class="resource-holder">
          <label for="type">Resource</label>

          <div class="select-holder">
            <v-select
              id="type"
              class="custom"
              placeholder="Select a type"
              :options="resourceTypeList"
              :clearable="false"
              :searchable="false"
              v-model="salesforceResourceType"
            >
              <template #open-indicator="{ attributes }">
                <span v-bind="attributes"> <Dropdown /> </span>
              </template>
            </v-select>
          </div>
        </div>

        <!-- Record Here -->
        <div class="resource-holder">
          <label for="type">Record</label>

          <div class="select-holder">
            <v-select
              class="custom"
              placeholder="Select an available record "
              :disabled="!this.salesforceResourceType"
              :options="salesForceRecords"
              :search="onSearch"
              @search="onSearch"
              v-model="salesforceResourceUID"
            >
              <template #open-indicator="{ attributes }">
                <span v-bind="attributes"> <Dropdown /> </span>
              </template>

              <template slot="no-options">No records found.</template>
            </v-select>
          </div>
        </div>

        <SmallLoader v-if="loadStatus" text="Loading..." />
      </form>

      <div v-if="!loadStatus" class="form-group flex items-center justify-end ">
        <button
          class="whitebutton-gemnote whitebutton-gemnote--small"
          :class="{ 'button-gemnote--disabled': isCreatingOrder }"
          @click="skipSalesForceLink"
          :disabled="isCreatingOrder"
        >
          <span> Skip</span>
        </button>

        <!-- <p @click="skipSalesForceLink">Skip</p> -->

        <button
          class="button-gemnote button-gemnote--small"
          :class="{ 'button-gemnote--disabled': isCreatingOrder }"
          :disabled="isCreatingOrder"
          @click="confirmOrder"
        >
          <span>Next</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SendGiftMenu from '@/components/SendGiftMenu'
import { isLoading, layouts, storeModules } from '../../helpers'
import { mapState } from 'vuex'
import Fuse from 'fuse.js'
import api from '@/axiosConfig'
const gemnoteAPI = api()
import store from '../../store'
import Dropdown from '../Universal/Dropdown.vue'
import Gemstripe from '../Universal/GemStripe.vue'

export default {
  name: 'LinkSalesForceRecord',
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (
      store.state.team.team.teamModuleNames.includes(storeModules.swag_store)
    ) {
      next()
    } else if (
      store.state.team.team.teamModuleNames.includes(storeModules.project)
    ) {
      next({ name: 'Projects' })
    }
  },
  components: {
    SendGiftMenu,
    SmallLoader: () => import('../SmallLoader'),
    Dropdown,
    Gemstripe
  },
  data() {
    return {
      disabled: true,
      resourceTypeList: ['Lead', 'Account', 'Contact']
    }
  },
  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.PAIGE_DASHBOARD)
    if (this.salesforceResourceType) {
      this.$store.dispatch(
        'integration/searchSalesForceByResourceType',
        this.salesforceResourceType
      )
    }
  },
  computed: {
    ...mapState({
      selectedRecipientId: state => state.order.selectedRecipientId,
      cardMessage: state => state.order.cardMessage,
      shoppingBagProducts: state => state.order.shoppingBagProducts,
      salesForceRecords: state => state.integration.salesForceRecords,
      loadingSalesforceByResourceType: state =>
        state.integration.loadingSalesforceByResourceType,
      isCreatingOrder: state => state.order.isCreatingOrder
    }),
    salesforceResourceType: {
      get() {
        return this.$store.state.order.salesforceResourceType
      },
      set(value) {
        if (value !== null && value !== undefined) {
          this.$store.dispatch(
            'integration/searchSalesForceByResourceType',
            value
          )
        }
      }
    },
    salesforceResourceUID: {
      get() {
        return this.$store.state.order.salesforceResourceUID
      },
      set(value) {
        this.$store.dispatch('order/setSalesforceRecordUID', value)
      }
    },
    user() {
      return this.$store.getters['profile/user']
    },
    loadStatus() {
      return isLoading(this.loadingSalesforceByResourceType)
    }
  },
  methods: {
    confirmOrder() {
      let errors = []

      if (!this.shoppingBagProducts.length) {
        errors.push('Please select a at least one product to continue.')
      }

      if (!this.salesforceResourceType) {
        errors.push('Please select a resource type or press skip to continue.')
      }

      if (!this.salesforceResourceUID) {
        errors.push(
          'Please select and associate a record or press skip to continue.'
        )
      }

      if (errors.length) {
        this.$store.dispatch('notification/pushNotification', {
          type: 'error',
          messages: errors
        })
        return
      }

      let orderData = {
        recipientId: this.selectedRecipientId,
        cardMessage: this.cardMessage,
        salesforceResourceType: this.salesforceResourceType,
        salesforceResourceUID: this.salesforceResourceUID.code
      }
      this.$store.dispatch('order/createOrder', orderData)
    },
    skipSalesForceLink() {
      let errors = []

      if (!this.shoppingBagProducts.length) {
        errors.push('Please select a at least one product to continue.')
      }

      if (!this.selectedRecipientId) {
        errors.push('Please select enter a recipient.')
      }

      if (errors.length) {
        this.$store.dispatch('notification/pushNotification', {
          type: 'error',
          messages: errors
        })
        return
      }

      this.$router.push({ name: 'ConfirmOrder' })
    },
    async onSearch(search, loading) {
      loading(true)
      const fuse = new Fuse(this.salesForceRecords, {
        keys: ['label'],
        shouldSort: true,
        threshold: 0.2
      })

      let searchResult = fuse.search(search).map(({ item }) => item)

      if (searchResult.length) {
        loading(false)
        return searchResult
      } else {
        let resultRecordsByName = await gemnoteAPI.get(
          `team/users/${this.user.id}/salesforce?resource_type=${this.salesforceResourceType}&filter[name]=${search}`
        )

        let resultRecordsByEmail = await gemnoteAPI.get(
          `team/users/${this.user.id}/salesforce?resource_type=${this.salesforceResourceType}&filter[email]=${search}`
        )

        let resultRecordsByCompany = await gemnoteAPI.get(
          `team/users/${this.user.id}/salesforce?resource_type=${this.salesforceResourceType}&filter[company]=${search}`
        )

        switch (this.salesforceResourceType) {
          case 'Lead':
            // eslint-disable-next-line no-case-declarations
            let leadResults = [
              ...resultRecordsByName.data['Leads'],
              ...resultRecordsByEmail.data['Leads'],
              ...resultRecordsByCompany.data['Leads']
            ]
            leadResults = leadResults.map(lead => {
              return {
                label: `${lead.name}- ${lead.company}`,
                code: lead.uid
              }
            })

            loading(false)
            return leadResults
          case 'Account':
            // eslint-disable-next-line no-case-declarations
            let accountResults = [
              ...resultRecordsByName.data['Accounts'],
              ...resultRecordsByEmail.data['Accounts'],
              ...resultRecordsByCompany.data['Accounts']
            ]
            accountResults = accountResults.map(account => {
              return {
                label: `${account.name}`,
                code: account.uid
              }
            })

            loading(false)
            return accountResults
          case 'Contact':
            // eslint-disable-next-line no-case-declarations
            let contactResults = [
              ...resultRecordsByName.data['Accounts'],
              ...resultRecordsByEmail.data['Accounts'],
              ...resultRecordsByCompany.data['Accounts']
            ]
            contactResults = contactResults.map(contact => {
              return {
                label: `${contact.name}- ${contact.account_name}`,
                code: contact.uid
              }
            })

            loading(false)
            return contactResults
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.form-group {
  margin-top: 4rem;
  margin-left: 8rem;

  button {
    margin-bottom: 1.25rem;
    height: 2.5rem;
    padding: 0 2rem;

    &:nth-child(1) {
      margin-right: 1rem;
    }
  }
}

.salesforce-container {
  margin-top: 6rem;

  .display-message {
    p {
      font-size: 0.875rem;
      color: $main-6;
    }
    .image-holder {
      display: flex;
      justify-content: center;
      margin-top: 2rem;
    }
  }
}

form {
  width: 35%;
  margin: 3rem auto;

  .resource-holder {
    display: flex;
    align-items: center;
    width: 90%;
    margin: auto;
    margin-bottom: 1rem;

    label {
      width: 30%;
      text-align: left;
      font-size: 0.813rem;
      font-weight: bold;
      color: $main-6;
    }

    .select-holder {
      width: 100%;
    }
  }
}

@media screen and (max-width: 1450px) and (min-width: 350px) {
  form {
    width: 55%;
  }
}

@media (max-width: 1100px) {
  form {
    width: 100%;
  }
  .resource-holder {
    width: 100%;
  }
}
</style>
